<page-layout>
  <header color="primary">
    <header-content>
      <h1>Velkommen i lyngbakkerne ved Gl. Rye</h1>
    </header-content>
  </header>

  <main>
    <p>
      Naturfond Gl. Rye er en fond, hvis primære formål er at støtte og opkøbe samt pleje udvalgte naturområder. Fondens
      sekundære formål er at sikre offentlighedens adgang til disse og støtte dertil hørende natur-, kultur- og
      historieformidling.
    </p>
    <p>
      Fonden har i begyndelsen af 2015, med støtte fra A.P.Møller og Hustru Chastine Mc-Kinney Møllers Fond til almene
      Formaal, opkøbt hovedparten af lyngbakkerne ved Gl. Rye og arbejder p.t. på at etablere et formidlingshus i
      tilknytning til Museet på Gl. Rye Mølle.
    </p>
    <p>
      Du kan finde mere information om fonden
      <a routerLink="/fonden/baggrund" routerLinkActive="active">her</a>.
    </p>

    <div>
      <div>
        <img class="mat-elevation-z4" style="width: 100%" src="/assets/pictures/lyngbakkerne/HPIM0418.JPG" />
      </div>
      <div>
        <img class="mat-elevation-z4" style="width: 100%" src="/assets/pictures/lyngbakkerne/HPIM0422.JPG" />
      </div>
    </div>
  </main>

  <footer color="primary">
    <footer-content></footer-content>
  </footer>
</page-layout>
